import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import API, { ErrorResponse } from '../../api/Api';
import EquivalencyRequest, { EquivalencyRequestParams, EquivalencyRequestSearchParams } from '../../models/EquivalencyRequest';
import Institution from '../../models/Institution';
import RequestState from '../Request/RequestState';
import { formatDate } from '../../shared/utils/formatDate';
import { ReviewRequesttParams } from '../../models/ReviewRequest';
import { Cardinality, CardinalityResponse } from '../../models/Cardinality';

export const fetchRequestFromSearch = createAsyncThunk<any, EquivalencyRequestSearchParams>(
  'equivalency/request',
  async (parameters, thunkAPI) => {
    try {
      const request:any = await API.getRequestBySearch(parameters);
      if (!request) return null
      return {
        ...request,
        editFiles: request.equivalencies?.editFiles ?? false,
        equivalencies: {
          ...request.equivalencies,
          activities: request.equivalencies.activities.map((act: any) => {
            return { ...act, approval_date: formatDate(act.approval_date) };
          })
        }
      };
    } catch (err:any) {
      console.log(err);
      if (!err.response) {
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const updateFilesRequest = createAsyncThunk<EquivalencyRequest, EquivalencyRequestParams>(
  'equivalency/updateFilesRequest',
  async (params, thunkAPI) => {
    try {
      const response = await API.putRequest(params, true);
      return response;
    } catch (err) {
      const error = err as ErrorResponse<Institution>
      if (!error.response) {
        throw err;
      }
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);
export const fetchCardinality = createAsyncThunk<CardinalityResponse, { ruleIds: string[] }>(
  'request/fetchCardinality',
  async (parameters, thunkAPI) => {
    try {
      const response = await API.getCardinality(parameters);
      return response;
    } catch (err) {
      const error = err as ErrorResponse<Institution>
      if (!error.response) {
        throw err;
      }
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const reviewRequest = createAsyncThunk<any, ReviewRequesttParams>(
  'equivalency/reviewRequest',
  async (data, thunkAPI) => {
    try {
      const response = await API.postReviewRequest(data);
      return response;
    } catch (err:any) {
      console.log(err);
      if (!err.response) {
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
interface SearchStoreInterface {
  searchRequest: any
  isEditFile: boolean
  cardinality: Cardinality[]
}

const initialState:SearchStoreInterface = {
  searchRequest: null,
  isEditFile: false,
  cardinality: []
};

const requestSearchSlice = createSlice({
  name: 'requestSearch',
  initialState,
  reducers: {
    reset: (state) => {
      state.searchRequest = null;
      state.isEditFile = false;
      state.cardinality = [];
    },
    resetCardinality: (state) => {
      state.cardinality = [];
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchRequestFromSearch.fulfilled, (state, action) => {
      state.searchRequest = action.payload;
      state.isEditFile = action.payload !== null && action.payload.state === RequestState.pending ? action.payload?.editFiles ?? false : false;
    });

    builder.addCase(updateFilesRequest.fulfilled, (state, action) => {
      state.isEditFile = action.payload !== null && action.payload.state === RequestState.pending ? action.payload?.editFiles ?? false : false;
    });
    builder.addCase(fetchCardinality.fulfilled, (state, action) => {
      state.cardinality = action.payload.cardinality ?? [];
    });
  }
});

export const { reset, resetCardinality } = requestSearchSlice.actions;

export default requestSearchSlice.reducer;
